module.exports = __webpack_public_path__ + "static/blog-img11-c68f0a02520e8eec719089e360659e5e.jpg";